export default "__VITE_ASSET__DuyS6aXN__"